import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveUser } from "../redux/features/app/userSlice";

const useUser = () => {
  let user;
  const dispatch = useDispatch();
  const storeUser = (data) => {
    dispatch(saveUser(data));
  };

  user = useSelector((state) => state.user.value);

  return { user, storeUser };
};

export default useUser;
